import {
  actionTypes,
  doSaveTrackRequestAction,
  doResetState,
  doSaveError,
  doSaveActionTypeAndPayload,
  doSavePersistentData,
  doGenerateOtp,
  doGenerateDoubleOtp
} from 'Store/actions/sca'
import { nullSafe } from 'Utility/globalMethods'
import { doShowToast } from 'Store/actions/toast'
import { doShowPopup } from 'Store/actions/popup'
// import { doLogout } from 'Store/actions/login'
import { push } from 'redux-first-history'
import { flowToastMapType } from 'Utility/flowToastMap'
import { flowPopupMapType } from 'Utility/flowPopupMap'
import { axiosInstance } from 'Api/index'

const WRONG_OTP = ['5707', 'WRONG_OTP', 'WRONG_DOUBLE_OTP']
const LAST_ATTEMPT = ['5708', 'WRONG_OTP_LAST_ATTEMPT', 'WRONG_DOUBLE_OTP_LAST_ATTEMPT']

export const resetHeaders = () => {
  delete axiosInstance.defaults.headers.otp
  delete axiosInstance.defaults.headers.otp2
  delete axiosInstance.defaults.headers.additionalInfo
  delete axiosInstance.defaults.headers.transactionId
  delete axiosInstance.defaults.headers.emailTransactionId
  delete axiosInstance.defaults.headers.user
  delete axiosInstance.defaults.headers.serviceId
  delete axiosInstance.defaults.headers.servicePayload
  delete axiosInstance.defaults.headers.idPhoneNumber
  delete axiosInstance.defaults.headers.channel
  delete axiosInstance.defaults.headers.type
}

const getPersistendData = (objectStructure, store) => {
  const transactionId = nullSafe(() => objectStructure.trxData[3], false)
    ? objectStructure.trxData[3]
    : nullSafe(() => objectStructure.transactionId, false)
      ? objectStructure.transactionId
      : null

  const emailTransactionId = nullSafe(() => objectStructure.emailTransactionId, false)
    ? objectStructure.emailTransactionId
    : null

  const result = {}

  if (transactionId) {
    result.transactionId = transactionId
  }

  if (emailTransactionId) {
    result.emailTransactionId = emailTransactionId
  }
  return {
    ...nullSafe(() => objectStructure.channel, false) ? { channel: objectStructure.channel } : { channel: nullSafe(() => store.getState().sca.persistentData.channel, '') },
    ...nullSafe(() => objectStructure.type, false) ? { type: objectStructure.type } : { type: nullSafe(() => store.getState().sca.persistentData.type, '') },
    ...nullSafe(() => objectStructure.additionalInfo, false) ? { additionalInfo: objectStructure.additionalInfo } : { additionalInfo: nullSafe(() => store.getState().sca.persistentData.additionalInfo, '') },
    ...result,
    ...nullSafe(() => objectStructure.trxData[0], false) ? { user: objectStructure.trxData[0] } : { user: nullSafe(() => store.getState().sca.persistentData.user, '') },
    ...nullSafe(() => objectStructure.serviceId, false) ? { serviceId: objectStructure.serviceId } : { serviceId: nullSafe(() => store.getState().sca.persistentData.serviceId, '') },
    ...nullSafe(() => objectStructure.servicePayload, false) ? { servicePayload: objectStructure.servicePayload } : { servicePayload: nullSafe(() => store.getState().sca.persistentData.servicePayload, '') },
    ...nullSafe(() => objectStructure.phoneNumbers[0].id, false) ? { idPhoneNumber: objectStructure.phoneNumbers[0].id } : { idPhoneNumber: nullSafe(() => store.getState().sca.persistentData.idPhoneNumber, '') },
    ...nullSafe(() => objectStructure.phoneNumbers[0].obfuscatedValue, false) ? { phoneNumber: objectStructure.phoneNumbers[0].obfuscatedValue } : { phoneNumber: nullSafe(() => store.getState().sca.persistentData.phoneNumber, '') },
    ...nullSafe(() => objectStructure.maskedData[0].obfuscatedValue, false) ? { maskedPhone: objectStructure.maskedData[0].obfuscatedValue } : { maskedPhone: nullSafe(() => store.getState().sca.persistentData.maskedPhone, '') }
  }
}
// This function dispatches an action to save the action type and payload when the action is related to SCA.
const saveScaAction = (store, action) => {
  store.dispatch(doSaveActionTypeAndPayload(action.type, action.payload))
}

// This function handles errors that occur during the SCA process. It dispatches different actions based on the error status and whether a popup key is present.
const handleSca = (store, action, scaSection) => {
  const trackRequestAction = action.type.substring(0, action.type.indexOf('_failure'))
  const persistentData = getPersistendData(action.error && action.error.data, store)

  store.dispatch(doSavePersistentData(persistentData))

  if (!scaSection.trackRequestAction) {
    store.dispatch(doSaveTrackRequestAction(trackRequestAction + '_success'))
  }

  const errorStatus = nullSafe(() => action.error.data.status, '')

  if (action.error && action.error.data && action.error.data.status && String(action.error.data.status) !== '0') { store.dispatch(doSaveError(action.error.data.status)) }
  switch (true) {
    case WRONG_OTP.includes(errorStatus):
      if (scaSection.otpType === 'isDoubleOtp') {
        store.dispatch(doShowToast(flowToastMapType.WRONG_DOUBLE_OTP_ERROR_TOAST))
      } else {
        store.dispatch(doShowToast(flowToastMapType.WRONG_OTP_ERROR_TOAST))
      }
      break
    case LAST_ATTEMPT.includes(errorStatus):
      if (scaSection.otpType === 'isDoubleOtp') {
        store.dispatch(doShowToast(flowToastMapType.LAST_ATTEMPT_DOUBLE_OTP_ERROR_TOAST))
      } else {
        store.dispatch(doShowToast(flowToastMapType.LAST_ATTEMPT_OTP_ERROR_TOAST))
      }
      break
    default:
      if (action.payload && action.payload.pathToRedirect) {
        const currentPath = window.location.pathname
        if (currentPath !== action.payload.pathToRedirect) {
          const routerData = nullSafe(() => action.payload.routerData, {})
          store.dispatch(push(action.payload.pathToRedirect, { ...routerData }))
        }
      } else if (action.payload && action.payload.isScaPopup) {
        const additionalData = nullSafe(() => action.payload.additionalData, {})
        store.dispatch(doShowPopup(flowPopupMapType.OTP_MODAL, { ...additionalData }))
      }
      break
  }
}

// This function handles OTP verification. It sets default headers and dispatches an action with the OTPs and other payload data.
const handleVerifyOtp = (store, action, scaSection) => {
  // Check if nextAction exists before proceeding
  if (!scaSection.nextAction || !scaSection.nextAction.actionToInvoke) {
    console.warn('SCA nextAction is null or missing actionToInvoke. Cannot proceed with OTP verification.')
    return
  }

  axiosInstance.defaults.headers.otp = nullSafe(() => action.payload.otp, '')
  // Double Otp
  axiosInstance.defaults.headers.otp2 = nullSafe(() => action.payload.emailOtp, '')

  if (nullSafe(() => scaSection.persistentData.additionalInfo, false)) {
    axiosInstance.defaults.headers.additionalInfo = scaSection.persistentData.additionalInfo
  }
  if (nullSafe(() => scaSection.persistentData.transactionId, false)) {
    axiosInstance.defaults.headers.transactionId = scaSection.persistentData.transactionId
  }
  // Double Otp
  if (nullSafe(() => scaSection.persistentData.emailTransactionId, false)) {
    axiosInstance.defaults.headers.emailTransactionId = scaSection.persistentData.emailTransactionId
  }
  if (nullSafe(() => scaSection.persistentData.user, false)) {
    axiosInstance.defaults.headers.user = scaSection.persistentData.user
  }

  store.dispatch({
    type: scaSection.nextAction.actionToInvoke,
    description: scaSection.nextAction.description,
    payload: {
      ...scaSection.nextAction.actionPayload
    }
  })
}

const handleRegenerateOtp = (store, scaSection, action) => {
  // reset the headers
  resetHeaders()
  const isIamRegenerate = action && action.payload && action.payload.isIamRegenerate
  const isDoubleSca = action && action.payload && action.payload.isDoubleOtp
  if (isIamRegenerate) {
    store.dispatch(doGenerateOtp())
  } else if (isDoubleSca) {
    store.dispatch(doGenerateDoubleOtp())
  } else {
    const isDoubleOtp = action && action.payload && action.payload.isDoubleOtp
    store.dispatch({ type: scaSection.nextAction.actionToInvoke, payload: scaSection.nextAction.actionPayload })
    store.dispatch(doShowToast(!isDoubleOtp ? flowToastMapType.GENERATED_NEW_OTP : flowToastMapType.GENERATED_NEW_DOUBLE_OTP))
  }
}

const updateDataDueRegenerateOtp = (store, action) => {
  const persistentData = getPersistendData(action.response)
  store.dispatch(doSavePersistentData(persistentData))
}

// This function checks if the action type matches the tracked successful request action in the SCA section of the state. If it does, it dispatches an action to reset the state.
const resetSca = (store, action, scaSection) => {
  const baseTrackAction = scaSection.trackRequestAction ? scaSection.trackRequestAction.replace('_success', '') : ''
  const isTrackRequestFailure = baseTrackAction && action.type === baseTrackAction + '_failure'
  if (action.type === scaSection.trackRequestAction) {
    store.dispatch(doResetState())
  } else if ((action && action.error && action.error.status && action.error.status !== Number(process.env.SCA_CODE)) && (scaSection && scaSection.persistentData) && !isTrackRequestFailure) {
    store.dispatch(doResetState())
    resetHeaders()
  }
}

// This function handles the case where the user has exceeded the number of attempts to enter the OTP. It dispatches an action to show a popup.
// const handleAttemptExceeded = (store) => {
//   store.dispatch(doShowPopup(flowPopupMapType.RECOVERY_ATTEMPTS_EXCEEDED_POPUP)) // TODO: check the popup
//   store.dispatch(doLogout({ stayOnPage: true }))
// }

const sca = (store) => (next) => (action) => {
  const scaSection = nullSafe(() => store.getState().sca, {})
  const newAction = action
  if (action && action.isSca) {
    saveScaAction(store, action)
  } else if (action.error && action.error.status === Number(process.env.SCA_CODE) && scaSection && scaSection.captureAndHandleSca) {
    handleSca(store, action, scaSection)
  } else if (action.type === actionTypes.DO_VERIFY_OTP) {
    handleVerifyOtp(store, action, scaSection)
  } else if (action.type === actionTypes.DO_REGENERATE_OTP) {
    handleRegenerateOtp(store, scaSection, action)
  } else if (action.type === actionTypes.GENERATE_OTP_SUCCESS || action.type === actionTypes.GENERATE_DOUBLE_OTP_SUCCESS) {
    updateDataDueRegenerateOtp(store, action)

    // } else if (action.error && action.error.status === 401 && action.error.data && (action.error.data.status === '5709' || action.error.data.status === 'WRONG_OTP_BLOCKED')) {
    //   handleAttemptExceeded(store)
    //   return
  } else {
    resetSca(store, action, scaSection)
  }
  return next(newAction)
}

export default sca
